import React from 'react';
import './Loader.scss';

function Loader({ isSmallLoader = false, isHomeLoader = false, text = '' }) {

  if (isSmallLoader) {
    return (
      <div className="loader-wrapper small">
        <div className="modern-spinner" />
      </div>
    );
  }

  if (isHomeLoader) {
    return (
      <div className="loader-wrapper home">
        <div className="modern-house-loader">
          <svg
            className="house-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <div className="pulse-ring" />
        </div>
        {text && <p className="loader-text">{text}</p>}
      </div>
    );
  }

  return (
    <div className="loader-overlay">
      <div className="modern-card">
        <div className="modern-spinner primary" />
        {text && <p className="loader-text">{text}</p>}
      </div>
    </div>
  );
}

export default Loader;
